export const FormLabel: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={"cpln-ant-form-label"}>{children}</div>;
};
